import { faQuestionSquare } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import styles from './Help.module.scss'

export const Help = () => {
  const { t } = useTranslation()
  const text = t('commons.upload.help')
  return (
    <div
      className={`${styles.bodyFont} d-flex justify-content-end align-items-center mt-2`}
    >
      {text}
      <FontAwesomeIcon className="ml-2" icon={faQuestionSquare} />
    </div>
  )
}
export default Help
